import * as zustand from 'zustand';

type NavigationMode = 'document' | 'spa'

export const useNavigationStore = zustand.create<{
  mode: NavigationMode
  routerReady: boolean
  setSPA: () => void
}>((set) => ({
  mode: 'document',      // SSR-safe default
  routerReady: false,   // Will be set to true once the router is initialized
  setSPA: () => 
    set(state =>
      state.routerReady
        ? state
        : { mode: 'spa', routerReady: true }
    ),
}))
